module.exports = __webpack_public_path__ + "img/D0003.13139ce1.svg";